export default __webpack_public_path__ + "static/media/tasks.e3966f1f.jpg";